<template>
  <div>
    <BaseTitle :title="$t('content.list_student')" />
    <div>
      <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
      <v-card class="mb-5" v-for="(item, index) in listStudent" :key="index">
        <div class="assignment-content">
          <div>
            <v-row class="border-item">
              <v-col md="1" align="center">
                <div class="mt-5 ml-5">
                  <svg-icon icon="ic_erapor" width="35" height="35" class="primary--text" />
                  <v-divider vertical></v-divider>
                </div>
              </v-col>
              <v-col md="10" class="mt-3">
                <div class="d-block">
                  <h3 class="d-inline">
                    <span class="header-content">{{ item.fullName }} </span>
                  </h3>
                </div>
                <div class="d-block">
                  <div>
                    <span class="body-content">
                      <span class="mr-3">
                        NIS :
                        <strong>{{ item.identityNumber }}</strong>
                      </span>
                      |
                      <span class="mr-3">
                        {{ $t('table.gender') }} :
                        <strong>{{ item.gender }}</strong>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="viewItem(item.studentId)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="getExport(item.studentId, item)">Print</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>

      <NoData class="mt-16" v-if="!listStudent.length" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import FileViewer from '@/components/FileViewerErapor';

export default {
  name: 'ListStudentErapor',
  components: {
    BaseTitle,
    NoData,
    FileViewer
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    dataClass: '',
    listStudent: [],
    loadingLoad: false,
    loadingPublish: false,
    titleData: '',
    search: '',
    form: {
      integrationName: '',
      eraporTemplateId: '',
      classroomId: '',
      fullName: '',
      schoolName: '',
      attendances: [],
      courses: []
    },
    dialogSync: false,
    dialogPreview: false,
    preview: {},
    published: ''
  }),
  methods: {
    getDataDetail() {
      this.$store.dispatch('TemplateErapor/fetchDetailIntegartion', this.$route.params.id).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('TemplateErapor/fetchListStudent', { classroomId: this.$route.params.classId ? this.$route.params.classId : this.$route.params.id })
        .then(res => {
          this.listStudent = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getPublish() {
      this.loadingPublish = true;
      this.$store
        .dispatch('TemplateErapor/checkPublish', { eraporIntegrationTemplateId: this.$route.params.id })
        .then(res => {
          this.published = res.published;
        })
        .finally(() => (this.loadingPublish = false));
    },
    publishExport() {
      this.loadingPublish = true;
      const payload = { eraporIntegrationTemplateId: this.$route.params.id, published: this.published === false ? true : false };

      this.$store
        .dispatch(`TemplateErapor/templatePublish`, payload)
        .then(data => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getPublish();
        })
        .finally(() => (this.loadingPublish = false));
    },
    getExport(id, item) {
      this.loadingLoad = true;
      this.$store
        .dispatch('TemplateErapor/exportDataTemplate', {
          eraporIntegrationTemplateId: this.$route.params.id && this.type !== 'school-admin' ? this.$route.params.id : '',
          studentId: id,
          classroomId: this.$route.params.classId ? this.$route.params.classId : this.$route.params.id
        })
        .then(res => {
          var blobURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `${this.form.integrationName} ${item.fullName} erapor`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `${this.form.integrationName} ${item.fullName} erapor.pdf`,
            size: '186 KB',
            dataUpload: res.data
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);
        })
        .finally(() => (this.loadingLoad = false));
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    synSchool() {
      this.dialogSync = true;
      this.$store
        .dispatch('TemplateErapor/generateTemplate', this.$route.params.id)
        .then(res => (this.listStudent = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.dialogSync = false;
          this.getData();
        });
    },
    viewItem(studentId) {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'eRaporGeneratorViewStudentClass', params: { studentId } });
      } else if (this.type === 'school-advisor') {
        this.$router.push({ name: 'eRaporGeneratorViewStudentAdvisorClass', params: { studentId } });
      } else if (this.type === 'school-admin') {
        this.$router.push({ name: 'eRaporGeneratorViewStudentSchoolAdminClass', params: { studentId } });
      }
    },
    back() {
      this.$router.push({ name: 'eRaporGeneratorIndex' });
    }
  },
  created() {
    this.getData();
    // this.getDataDetail();
    // this.getPublish();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
</style>
